const PropTypes = require('prop-types');
const React = require('react');

const BumpViewsImgSrc = require('../../../../../images/products/bump-scale.svg');
const HideableSlider = require('./hideable_slider');

const BumpChange = ({
  bidSlider,
  impressions,
  salesCount,
  salesSpent,
  salesRevenue,
  showMobileSlider,
  sliderToggle,
  currentBid,
}) => (
  <div className="product-bump__wrapper">
    <div className="product-bump__overview-col">
      <h4 className="product-bump__overview-col__stat-heading">{I18n.t('js.bump.change.performance')}</h4>
      <ul className="product-bump__overview-col__stats">
        <li>
          <div className="product-bump__overview-col__stats__stat">
            {impressions}
          </div>
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.impressions')}
          </div>
        </li>
        <li className="inline-block scaling-mlr-2">
          <div className="product-bump__overview-col__stats__stat">
            {salesCount}
          </div>
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.numberSold')}
          </div>
        </li>
        <li>
          <div
            className="product-bump__overview-col__stats__stat"
            dangerouslySetInnerHTML={{ __html: salesSpent }}
          />
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.spent')}
          </div>
        </li>
        <li>
          <div
            className="product-bump__overview-col__stats__stat"
            dangerouslySetInnerHTML={{ __html: salesRevenue }}
          />
          <div className="product-bump__overview-col__stats__label">
            {I18n.t('js.bump.change.sales')}
          </div>
        </li>
      </ul>
    </div>
    <div className="product-bump__slider-col">
      <HideableSlider
        label={I18n.t('js.bump.change.adjustRate')}
        sliderToggle={sliderToggle}
        showMobileSlider={showMobileSlider}
        currentBid={currentBid}
      >
        <h4 className="product-bump__slider-col__label">{I18n.t('js.bump.change.adjustRate')}</h4>
        <div className="product-bump__views-scale">
          <img src={BumpViewsImgSrc} alt={I18n.t('js.bump.setup.bumpChart')} />
          <div className="product-bump__views-scale__more">{I18n.t('js.bump.setup.moreViews')}</div>
          <div className="product-bump__views-scale__most-popular product-bump__views-scale__most-popular--new">
            {I18n.t('js.bump.setup.mostPopular')}
          </div>
          <div className="product-bump__views-scale__much-more">{I18n.t('js.bump.setup.manyMoreViews')}</div>
        </div>
        {bidSlider}
      </HideableSlider>
    </div>
  </div>
);

BumpChange.propTypes = {
  bidSlider: PropTypes.element.isRequired,
  impressions: PropTypes.number,
  salesCount: PropTypes.number,
  salesSpent: PropTypes.string,
  salesRevenue: PropTypes.string,
  hasComparisonShoppingPage: PropTypes.bool,
  showMobileSlider: PropTypes.bool,
  sliderToggle: PropTypes.func,
  currentBid: PropTypes.number,
};

module.exports = BumpChange;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/bump_for_new/bump_change.jsx